import Swiper from 'swiper';

const swiper = new Swiper(".swiper", {
  spaceBetween: 13,
  grabCursor: true,
  slidesPerView: "auto",
});
